import React from 'react'
import { Field, reduxForm } from 'redux-form'
// import { useDispatch } from "react-redux";
import { validate } from "./validate";

import Icon from '../../../icons';
import LoaderComponent from '../../../components/Loader';
import FormDatePicker from '../../../components/FormComponents/formDatePicker';

let AddFollowUp = props => {
    const { handleSubmit, buttonLoading } = props;


    const handleCancelClick = () => {
        props.onClose();
    }

    return (
        <div>
            <div className="modalHeader alignMiddle" >
                <h2 className="flexGrow alignBase flexWrap">Add Follow Up Diary</h2>
                <div className="alignRight alignMiddle">
                    <a className="h__16" href="javascript:void(0)" onClick={handleCancelClick}><Icon name="close" className="icon" /></a>
                </div>
            </div>
            <form onSubmit={handleSubmit((values) => props.onSubmit("save", values))} >
                <div className="modalBody overflowNone">
                    <div className="creationForm diaryCreation">
                        <p>Please select one or more Follow Up Diary due dates. A duplicate diary will be created for each Follow Up date.</p>
                        <div className="formRow">
                            {[1, 2, 3].map((i) => (
                                <div className={`wth-4 ${i < 3 ? 'mb' : ''}`} key={i}>
                                    <Field
                                        component={FormDatePicker}
                                        name={`followUpDueDate${i}`}
                                        label={`Follow Up Diary #${i}`}
                                        popperClassName=""
                                        showTime={true}
                                        showSysTime={false}
                                        shouldCloseOnSelect={false}
                                    />
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
                <div className="modalFooter">
                    <div className="rowFlex alignRight">
                        <button disabled={ buttonLoading } className="btn buttonGradient" type="submit">
                            {buttonLoading && <LoaderComponent  /> }
                            <span style={{visibility: buttonLoading ? "hidden" : ""}}>Save</span>
                        </button>
                        <button className="btn link" type="button" onClick={handleCancelClick}>Cancel</button>
                    </div>
                </div>
            </form>
        </div>
    )
}

AddFollowUp = reduxForm({
    form: 'diaryCreation',
    destroyOnUnmount: false,
    enableReinitialize: true,
    keepDirtyOnReinitialize: true,
    validate,
    touchOnBlur: false,
})(AddFollowUp)

export default AddFollowUp;